var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApOccupationalTherapyAustralia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 317.48242 122.26025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M276.24023,26.48535c-0.00586-0.04785-0.02148-0.09766-0.02734-0.1416 c-0.13086-0.74023-0.08984-1.46582,0.08398-2.08398c-0.53906,0.00781-1.06055-0.30859-1.47461-0.8457 c0.00586,0.03516,0.01758,0.07129,0.02539,0.10547c0.13477,0.81055,0.06445,1.60156-0.16992,2.24219 C275.24023,25.64551,275.80469,25.92578,276.24023,26.48535z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M270.42773,31.5293c0.17578,1.03613,0.82031,1.76465,1.50586,1.76465 c0.08789,0,0.17773-0.01465,0.26563-0.03809c0.77734-0.2207,1.24219-1.34668,1.03906-2.51855 c-0.20117-1.16602-0.99609-1.9375-1.77148-1.71973C270.69141,29.2373,270.22266,30.36133,270.42773,31.5293z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M272.50977,36.53516c0.17969,1.03613,0.82227,1.7627,1.50781,1.7627c0.08789,0,0.17773-0.0127,0.26563-0.03613 c0.77539-0.2207,1.24023-1.34766,1.03906-2.51855c-0.20117-1.16602-0.99414-1.9375-1.77148-1.72168 C272.77344,34.24121,272.31055,35.36719,272.50977,36.53516z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M272.35547,21.00586c0.62109-0.17383,1.25781,0.13379,1.74023,0.74414 c-0.01367-0.04883-0.02148-0.10059-0.0293-0.15039c-0.12695-0.70801-0.09375-1.40039,0.0625-2 c-0.54883-0.03809-1.08008-0.38379-1.5-0.94824c0.12891,0.88379-0.00391,1.74023-0.32031,2.37207 C272.32422,21.01953,272.33789,21.01367,272.35547,21.00586z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M278.80273,34.97363c0.59961-0.16797,1.21484,0.1123,1.68555,0.68555 c-0.03125-0.10742-0.05273-0.21582-0.07031-0.3252c-0.11523-0.64648-0.09375-1.27246,0.02734-1.83008 c-0.62891-0.06445-1.22656-0.56836-1.63281-1.33789c0.05078,0.16113,0.0957,0.33594,0.125,0.51367 c0.1582,0.88184,0.01758,1.74414-0.30859,2.35742C278.68359,35.01172,278.74414,34.98926,278.80273,34.97363z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M276.71875,30.44141c0.68164-0.19141,1.375,0.25391,1.81836,1.06641 c-0.07031-0.21191-0.12305-0.43066-0.16797-0.66016c-0.10547-0.63379-0.09375-1.25781,0.02539-1.81641 c-0.53711-0.01953-1.05664-0.36133-1.45898-0.91211c0,0.00879,0.00195,0.00879,0.00195,0.01465 c0.15039,0.84961,0.04297,1.68555-0.24609,2.31543C276.70117,30.44531,276.71875,30.44141,276.71875,30.44141z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M258.25,46.46582c-0.30859,0.08789-0.49609,0.5498-0.41016,1.03613 c0.07617,0.42773,0.33594,0.7334,0.61328,0.7334c0.03516,0,0.06836-0.00391,0.10547-0.01367 c0.30859-0.08789,0.49219-0.55762,0.4043-1.04004C258.88086,46.69922,258.55859,46.37988,258.25,46.46582z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M276.00586,39.27148c-0.77734,0.21777-1.24219,1.34766-1.04102,2.51367 c0.17969,1.03613,0.82031,1.76074,1.50391,1.76074c0.08984,0,0.17969-0.01074,0.26953-0.03613 c0.77344-0.21875,1.23828-1.3457,1.03906-2.51465C277.57422,39.83008,276.78125,39.05566,276.00586,39.27148z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M261.52734,43.69922c-0.08203-0.4834-0.40625-0.80176-0.71484-0.71777 c-0.30859,0.08789-0.49414,0.55371-0.4082,1.03809c0.07617,0.42578,0.33594,0.73438,0.61133,0.73438 c0.03516,0,0.07031-0.00586,0.10547-0.01465C261.43164,44.65332,261.61523,44.18359,261.52734,43.69922z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M265.38672,46.8916c-0.38672,0.11035-0.63086,0.66797-0.52734,1.25 c0.08789,0.50781,0.4043,0.87012,0.75,0.87012c0.04492,0,0.0918-0.00391,0.13672-0.02051 c0.38672-0.10742,0.625-0.67578,0.52539-1.25391C266.17383,47.16113,265.77539,46.7832,265.38672,46.8916z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M265.15039,44.03125c-0.09961-0.57617-0.49609-0.95605-0.88672-0.8457 c-0.38672,0.1084-0.63086,0.66797-0.52539,1.25c0.08398,0.50586,0.40234,0.86816,0.74805,0.86816 c0.04492,0,0.0918-0.00391,0.13672-0.02051C265.01172,45.17578,265.25195,44.60938,265.15039,44.03125z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M261.68359,46.27148c-0.31055,0.08789-0.49805,0.55176-0.4082,1.03613 c0.07422,0.42578,0.33398,0.7334,0.61133,0.7334c0.03711,0,0.07031-0.00391,0.10742-0.01367 c0.30664-0.08594,0.49023-0.55566,0.4043-1.04004C262.31641,46.50781,261.99414,46.18555,261.68359,46.27148z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M263.50195,80.29932c0.4707-0.0293,0.93555,0.17578,1.33203,0.56055 c-0.04688-0.56055,0.00195-1.0957,0.12695-1.57227c-0.56641-0.10938-1.09375-0.55859-1.46875-1.23438 c0.04688,0.16016,0.08789,0.33203,0.11328,0.51172C263.69922,79.18799,263.6543,79.78955,263.50195,80.29932z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M260.13281,90.9126c-0.01367-0.54492,0.0625-1.06445,0.21094-1.51953 c-0.52344-0.16797-1.00781-0.63672-1.33984-1.30273c0.04883,0.16602,0.08789,0.33984,0.11133,0.52148 c0.11133,0.73242,0.03711,1.42969-0.17578,2C259.35156,90.53564,259.76367,90.65479,260.13281,90.9126z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M274.09375,43.42969c-0.17969-1.0498-0.89258-1.74609-1.58984-1.54785 c-0.70117,0.19531-1.11914,1.20801-0.93555,2.25781c0.16016,0.92969,0.73633,1.58203,1.35547,1.58203 c0.07813,0,0.1582-0.00977,0.23828-0.03418C273.85742,45.49316,274.27344,44.47754,274.09375,43.42969z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M258.89648,98.93213c-0.08398-0.64453-0.05273-1.26563,0.07617-1.82031 c-0.4082-0.18164-0.7832-0.53906-1.08789-1.01953c0.14453,1.00586-0.07031,1.95703-0.51172,2.54688 c0.08789-0.03906,0.18555-0.07031,0.28516-0.08984C258.0918,98.46729,258.52148,98.61768,258.89648,98.93213z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M268.8418,17.96387c-0.47852-0.09082-0.92773-0.42871-1.2793-0.94629 c0.00391,0.02637,0.01367,0.05371,0.01563,0.08203c0.125,0.70605,0.0918,1.40234-0.05859,2.00781 c0.60352,0.07422,1.18555,0.57813,1.55859,1.34375c-0.10547-0.26563-0.19141-0.55762-0.24609-0.87109 C268.73242,19.01563,268.74609,18.46191,268.8418,17.96387z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M271.03125,25.03516c-0.03516-0.13379-0.07227-0.27344-0.0957-0.42188 c-0.17188-0.97363-0.0293-1.92188,0.32813-2.61133c-0.01172,0.00391-0.01758,0.00586-0.02734,0.00781 c-0.7793,0.22363-1.57031-0.32422-2.04297-1.30273c0.10352,0.27051,0.1875,0.56055,0.24414,0.875 c0.15625,0.90723,0.03516,1.80176-0.28125,2.46191c0.01172-0.00488,0.02148-0.0127,0.03516-0.0166 C269.86914,23.8418,270.56836,24.25977,271.03125,25.03516z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M268.8418,36.50586c0.08008,0,0.16016-0.01074,0.24023-0.03223 c0.69727-0.19629,1.11719-1.20996,0.93359-2.26172c-0.17773-1.0459-0.89453-1.74219-1.5918-1.5459 c-0.69727,0.19727-1.11523,1.20703-0.93359,2.25781C267.65039,35.85547,268.22656,36.50586,268.8418,36.50586z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M271.88672,38.71191c-0.17969-1.05078-0.89063-1.74414-1.58984-1.54785 c-0.69922,0.19531-1.11719,1.20703-0.93555,2.25586c0.16211,0.93164,0.73633,1.58398,1.35352,1.58398 c0.08008,0,0.16016-0.01074,0.24023-0.03223C271.65039,40.77539,272.07031,39.75977,271.88672,38.71191z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M269.17188,44.47949c-0.58203,0.16406-0.90039,1.11035-0.71484,2.11621 c0.16797,0.9082,0.69141,1.5498,1.21875,1.5498c0.05859,0,0.11523-0.00586,0.17383-0.02441 c0.58984-0.16211,0.9043-1.11133,0.71875-2.11914C270.37891,44.99805,269.75586,44.31348,269.17188,44.47949z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M268.57031,41.78711c-0.16602-0.91406-0.73242-1.53125-1.26172-1.38184 c-0.5293,0.14844-0.81836,1.00879-0.64844,1.92188c0.15039,0.81641,0.62305,1.40039,1.10156,1.40039 c0.05469,0,0.10742-0.00781,0.16016-0.02441C268.44922,43.55566,268.74414,42.69531,268.57031,41.78711z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -142.96631,
    y1: 486.74854,
    x2: -140.96631,
    y2: 486.74854,
    gradientTransform: "matrix(-30.79825 -36.70393 -36.70393 30.79825 13760.80371 -20164.34961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M283.12305,82.58838c8.77734-14.19531,13.55664-33.81885,9.91602-53.45068 c0,0,7.02734-10.53027,16.98438-17.18848c0.56641-0.3877,2.75977-1.67383,2.9043-1.76758 c1.47266-0.81445,2.99219-1.53027,4.55469-2.09766c-12.66016-2.76465-28.38281,3.42188-31.38281,5.28125 C277.77148,2.3457,260.64258,0.48145,260.64258,0.48145l-0.99219-0.17773C257.67578,0.09766,255.78516,0,253.97266,0 c-10.51953,0-18.36719,3.27344-24.36133,7.16602c-0.0625,0.0293-0.11523,0.06543-0.16797,0.10742 c-4.42773,2.89844-7.83984,6.12402-10.56445,8.5918c1.1582-0.79199,2.3125-1.4873,3.47266-2.10742 c-0.03711,0.19922-0.04102,0.42188-0.00195,0.64355c0.11719,0.69824,0.57227,1.15234,1.01172,1.03027 c0.43945-0.12402,0.69336-0.78027,0.57813-1.46973c-0.0625-0.34863-0.20898-0.63672-0.39648-0.82031 c0.65039-0.32031,1.29688-0.61035,1.94336-0.88184c0.25781,0.77734,0.83008,1.25586,1.37695,1.09766 c0.60156-0.16797,0.9668-1.01953,0.86914-1.94824c0.60352-0.20215,1.20313-0.38379,1.80078-0.5498 c0.28906,0.25977,0.625,0.37988,0.95898,0.28613c0.31055-0.08789,0.56836-0.35156,0.74219-0.70996 c0.78906-0.17188,1.56836-0.31445,2.34375-0.42773c-0.06445,0.42188-0.07227,0.87598,0.01172,1.34375 c0.26563,1.51758,1.26367,2.53223,2.23438,2.25977c0.9707-0.27539,1.53711-1.72754,1.27344-3.24805 c-0.04297-0.24609-0.10742-0.46777-0.18555-0.68359c0.03906,0,0.08203,0,0.11914-0.00195 c0.46484,0.98145,1.25586,1.5459,2.03125,1.32813c0.11523-0.03223,0.22461-0.08594,0.33203-0.1543 c-0.45898,0.57031-0.67969,1.52832-0.50391,2.52832c0.24609,1.40527,1.17578,2.33984,2.07422,2.08789 c0.89648-0.25391,1.42773-1.59863,1.17969-3.00391c-0.25-1.4082-1.17969-2.34082-2.07813-2.08887 c-0.09375,0.02637-0.18359,0.07227-0.26953,0.12305c0.1875-0.2207,0.33789-0.49219,0.45117-0.80664 c0.54102,0.02637,1.07813,0.06445,1.60742,0.11426c0,0.25,0.01563,0.50391,0.06055,0.76172 c0.29883,1.67383,1.40625,2.78809,2.47656,2.48828c0.00977-0.00195,0.01758-0.00586,0.0293-0.00781 c-0.22461,0.56738-0.29883,1.2793-0.16992,2.01367c0.25977,1.47363,1.23242,2.45801,2.16992,2.19238 c0.9375-0.2666,1.49023-1.67676,1.23047-3.14648c-0.24805-1.43555-1.18359-2.40234-2.10352-2.19629 c0.19141-0.42969,0.29492-0.94531,0.30859-1.49512c0.57813,0.11914,1.14648,0.25195,1.70117,0.39355 c-0.0918,0.5-0.10156,1.05176,0,1.62012c0.28516,1.62207,1.31445,2.73145,2.35547,2.55566 c-0.20313,0.56641-0.26563,1.27246-0.14258,1.99219c0.26563,1.50391,1.26172,2.52051,2.22656,2.24219 c0.96094-0.27051,1.5293-1.71973,1.26758-3.22461c-0.24219-1.39551-1.10742-2.35352-1.99609-2.2832 c0.19727-0.4707,0.29492-1.03613,0.2832-1.63477c0.54297,0.20605,1.05859,0.41797,1.55273,0.63477 c-0.12891,0.54004-0.16016,1.15918-0.04688,1.79199c0.2793,1.56738,1.28516,2.62988,2.28906,2.4375 c-0.20313,0.53223-0.26953,1.19824-0.15234,1.88574c0.24805,1.39844,1.16797,2.33691,2.05664,2.07813 c0.89258-0.25195,1.41797-1.58984,1.17969-2.98535c-0.23242-1.29883-1.03906-2.17676-1.86523-2.10059 c0.14844-0.32813,0.24805-0.70996,0.28906-1.12207c0.41016,0.28613,0.81641,0.57813,1.2168,0.87598 c0.01172,0.23438,0.0293,0.47266,0.07227,0.71191c0.31836,1.80859,1.49805,3.01855,2.64844,2.70215 c-0.18945,0.51074-0.25195,1.13379-0.13867,1.78027c0.23242,1.31641,1.09961,2.2002,1.94336,1.95996 c0.70508-0.19824,1.16211-1.12598,1.1543-2.19629c0.67383,0.70801,1.31445,1.44238,1.91406,2.20605 c0.23633,1.19824,0.89453,2.08984,1.64648,2.32813c0.1875,0.30176,0.36719,0.6084,0.53906,0.91797 c-0.07031,0.44434-0.07617,0.92773,0.01172,1.41992c0.20703,1.16211,0.81641,2.03418,1.5293,2.30566 c0,0-1.32422,2.63867-3.63477,6.06055c0.43359,0.16406,0.82422,0.73828,0.96484,1.49414 c0.18555,1.00781-0.13281,1.95801-0.7168,2.12207c-0.58203,0.16602-1.20703-0.51855-1.39258-1.52637 c-0.02539-0.12988-0.04102-0.25977-0.04688-0.3877c-0.44336,0.61426-0.91211,1.24023-1.4043,1.87012 c0.3418-0.00391,0.66992,0.33203,0.75586,0.8457c0.10156,0.57617-0.13867,1.14453-0.52539,1.25391 c-0.39648,0.1123-0.78711-0.28027-0.88672-0.85156c-0.02344-0.14063-0.02539-0.27832-0.01367-0.41016 c-3.84766,4.72559-9.04688,9.50391-14.92383,10.62988c6.64258,0.11426,13.63672,0.08984,19.71875-1.27832 c2.19141-0.49219,4.10742-1.19922,6.03516-2.0957c-0.0918,0.47559-0.10547,1.00391-0.00977,1.54199 c0.08789,0.50195,0.25,0.94824,0.46875,1.31348c0.0332,0.81641,0.06055,1.62891,0.07617,2.43066 c-0.15039-0.01465-0.30273-0.00781-0.45313,0.03223c-0.04883,0.01367-0.10352,0.03516-0.1543,0.05176 c0.18555-0.52051,0.24805-1.16016,0.13281-1.81836c-0.24609-1.3916-1.16016-2.31543-2.04297-2.06543 c-0.89063,0.25195-1.41211,1.57617-1.16797,2.96777c0.24414,1.38379,1.14648,2.30176,2.0293,2.06543 c-0.27344,0.65234-0.36914,1.48242-0.23242,2.34473c0.22461,1.33398,0.96875,2.32129,1.80078,2.52344 c0,0.0127-0.00195,0.02441-0.00195,0.03613c-0.15039,0.52246-0.21484,1.11816-0.1582,1.74219 c-0.38672-0.37402-0.84375-0.56641-1.31055-0.50391c0.16602-0.53223,0.21289-1.17188,0.10547-1.82227 c-0.25195-1.49414-1.23047-2.51172-2.19141-2.26563c-0.95508,0.25-1.5332,1.66602-1.28125,3.16992 c0.22852,1.37695,1.07422,2.33984,1.95117,2.29883c-0.22266,0.60889-0.29883,1.36377-0.17383,2.14111 c0.00195,0.03125,0.00781,0.06055,0.01758,0.09766c-0.4668-0.58203-1.0625-0.87891-1.6543-0.73828 c-0.19727,0.04883-0.37695,0.13281-0.54102,0.25781c0.36914-0.53125,0.53711-1.35986,0.39258-2.21338 c-0.22266-1.31641-1.08008-2.20605-1.92383-1.98633c-0.8457,0.20801-1.34961,1.45313-1.12891,2.77344 c0.2207,1.3208,1.08008,2.21533,1.92383,1.99658c0.125-0.03516,0.24414-0.09375,0.35742-0.17188 c-0.49414,0.66406-0.72656,1.73047-0.54883,2.84766c0.22656,1.42188,1.04297,2.46484,1.93555,2.59375 c-0.14258,0.45313-0.21484,0.96875-0.20117,1.50977c-0.41406-0.42773-0.91016-0.6582-1.41211-0.61133 c0.10742-0.47266,0.13477-1.00391,0.04297-1.55273c-0.24023-1.51367-1.22461-2.5625-2.19727-2.33008 c-0.97461,0.22656-1.56836,1.64453-1.32813,3.16602c0.21484,1.33398,0.99023,2.30273,1.83594,2.36719 c-0.17578,0.57227-0.24219,1.24609-0.16211,1.95117c-0.45117-0.49023-1.00977-0.73633-1.56836-0.61719 c-0.00977,0.00391-0.02734,0.00781-0.03711,0.01172c0.22266-0.53516,0.30664-1.2207,0.19141-1.9375 c-0.2207-1.41797-1.14063-2.39844-2.04883-2.18359c-0.91211,0.21094-1.46875,1.54297-1.23828,2.96094 c0.20703,1.36328,1.06641,2.30078,1.93359,2.19141c-0.3457,0.67383-0.49219,1.59375-0.34961,2.55859 c0.0332,0.22461,0.08203,0.44531,0.14648,0.65234c-0.43945-0.75977-1.09375-1.19531-1.75-1.05859 c-0.99023,0.21484-1.60742,1.63477-1.37109,3.18359c0.20508,1.36523,1.00781,2.36328,1.875,2.42773 c-0.22656,0.60547-0.32031,1.34961-0.23047,2.13086c-0.45313-0.49609-1.00391-0.75391-1.55859-0.63281 c-0.16992,0.03516-0.33008,0.10742-0.47656,0.20313c0.41016-0.55273,0.61328-1.43945,0.4707-2.38086 c-0.21289-1.41992-1.125-2.41992-2.03906-2.22656c-0.91797,0.19727-1.48828,1.50781-1.27344,2.93164 c0.2168,1.42969,1.13477,2.42969,2.04688,2.23438c0.11914-0.02344,0.24023-0.07422,0.34766-0.13672 c-0.51367,0.65625-0.76172,1.74219-0.5918,2.88672c0.0332,0.21094,0.07422,0.40625,0.13281,0.59375 c-0.44922-0.875-1.16602-1.38672-1.88672-1.23438c-1.01953,0.21289-1.65039,1.67969-1.41406,3.26953 c0.22852,1.50391,1.15625,2.58203,2.12109,2.5c-0.29688,0.68555-0.40625,1.55859-0.26953,2.47266 c0.00586,0.04688,0.01367,0.08984,0.02344,0.13672c-0.43164-0.63672-1.03125-0.99023-1.63086-0.85938 c-0.98828,0.20703-1.60156,1.63281-1.36914,3.17773c0.22656,1.53906,1.21875,2.61523,2.20703,2.4082 c0.07617-0.01563,0.14648-0.04297,0.21289-0.06836c-0.48242,0.63477-0.72656,1.66016-0.56836,2.75586 c0.0957,0.66797,0.32617,1.25,0.63281,1.70313c-0.09375,0.10547-0.18359,0.21094-0.27539,0.31445 c-0.00195-0.01953-0.00195-0.03711-0.00586-0.05664c-0.21094-1.41406-1.11523-2.40234-2.02344-2.20898 c-0.90625,0.19336-1.47266,1.49609-1.25391,2.9082c0.125,0.81641,0.48438,1.48438,0.93945,1.875 c-1.12305,1.14063-1.83203,1.76953-1.83203,1.76953S267.42773,105.37354,283.12305,82.58838z M258.55859,48.22168 c-0.03711,0.00977-0.07031,0.01367-0.10547,0.01367c-0.27734,0-0.53711-0.30566-0.61328-0.7334 c-0.08594-0.48633,0.10156-0.94824,0.41016-1.03613c0.30859-0.08594,0.63086,0.2334,0.71289,0.71582 C259.05078,47.66406,258.86719,48.13379,258.55859,48.22168z M261.01563,44.75391c-0.27539,0-0.53516-0.30859-0.61133-0.73438 c-0.08594-0.48438,0.09961-0.9502,0.4082-1.03809c0.30859-0.08398,0.63281,0.23438,0.71484,0.71777 c0.08789,0.48438-0.0957,0.9541-0.40625,1.04004C261.08594,44.74805,261.05078,44.75391,261.01563,44.75391z M261.99414,48.02734 c-0.03711,0.00977-0.07031,0.01367-0.10742,0.01367c-0.27734,0-0.53711-0.30762-0.61133-0.7334 c-0.08984-0.48438,0.09766-0.94824,0.4082-1.03613c0.31055-0.08594,0.63281,0.23633,0.71484,0.71582 C262.48438,47.47168,262.30078,47.94141,261.99414,48.02734z M264.48633,45.30371c-0.3457,0-0.66406-0.3623-0.74805-0.86816 c-0.10547-0.58203,0.13867-1.1416,0.52539-1.25c0.39063-0.11035,0.78711,0.26953,0.88672,0.8457 c0.10156,0.57813-0.13867,1.14453-0.52734,1.25195C264.57813,45.2998,264.53125,45.30371,264.48633,45.30371z M265.74609,48.99121 c-0.04492,0.0166-0.0918,0.02051-0.13672,0.02051c-0.3457,0-0.66211-0.3623-0.75-0.87012 c-0.10352-0.58203,0.14063-1.13965,0.52734-1.25c0.38867-0.1084,0.78711,0.26953,0.88477,0.8457 C266.37109,48.31543,266.13281,48.88379,265.74609,48.99121z M276.73828,43.50977 c-0.08984,0.02539-0.17969,0.03613-0.26953,0.03613c-0.68359,0-1.32422-0.72461-1.50391-1.76074 c-0.20117-1.16602,0.26367-2.2959,1.04102-2.51367c0.77539-0.21582,1.56836,0.55859,1.77148,1.72363 C277.97656,42.16406,277.51172,43.29102,276.73828,43.50977z M278.9375,32.67969c-0.0293-0.17773-0.07422-0.35254-0.125-0.51367 c0.40625,0.76953,1.00391,1.27344,1.63281,1.33789c-0.12109,0.55762-0.14258,1.18359-0.02734,1.83008 c0.01758,0.10938,0.03906,0.21777,0.07031,0.3252c-0.4707-0.57324-1.08594-0.85352-1.68555-0.68555 c-0.05859,0.01563-0.11914,0.03809-0.17383,0.06348C278.95508,34.42383,279.0957,33.56152,278.9375,32.67969z M276.9375,28.13379 c0-0.00586-0.00195-0.00586-0.00195-0.01465c0.40234,0.55078,0.92188,0.89258,1.45898,0.91211 c-0.11914,0.55859-0.13086,1.18262-0.02539,1.81641c0.04492,0.22949,0.09766,0.44824,0.16797,0.66016 c-0.44336-0.8125-1.13672-1.25781-1.81836-1.06641c0,0-0.01758,0.00391-0.02734,0.00781 C276.98047,29.81934,277.08789,28.9834,276.9375,28.13379z M274.84766,23.51953c-0.00781-0.03418-0.01953-0.07031-0.02539-0.10547 c0.41406,0.53711,0.93555,0.85352,1.47461,0.8457c-0.17383,0.61816-0.21484,1.34375-0.08398,2.08398 c0.00586,0.04395,0.02148,0.09375,0.02734,0.1416c-0.43555-0.55957-1-0.83984-1.5625-0.72363 C274.91211,25.12109,274.98242,24.33008,274.84766,23.51953z M275.32227,35.74316c0.20117,1.1709-0.26367,2.29785-1.03906,2.51855 c-0.08789,0.02344-0.17773,0.03613-0.26563,0.03613c-0.68555,0-1.32813-0.72656-1.50781-1.7627 c-0.19922-1.16797,0.26367-2.29395,1.04102-2.51367C274.32813,33.80566,275.12109,34.57715,275.32227,35.74316z  M272.62891,18.65137c0.41992,0.56445,0.95117,0.91016,1.5,0.94824c-0.15625,0.59961-0.18945,1.29199-0.0625,2 c0.00781,0.0498,0.01563,0.10156,0.0293,0.15039c-0.48242-0.61035-1.11914-0.91797-1.74023-0.74414 c-0.01758,0.00781-0.03125,0.01367-0.04688,0.01758C272.625,20.3916,272.75781,19.53516,272.62891,18.65137z M273.23828,30.7373 c0.20313,1.17188-0.26172,2.29785-1.03906,2.51855c-0.08789,0.02344-0.17773,0.03809-0.26563,0.03809 c-0.68555,0-1.33008-0.72852-1.50586-1.76465c-0.20508-1.16797,0.26367-2.29199,1.03906-2.51172 C272.24219,28.7998,273.03711,29.57129,273.23828,30.7373z M267.51953,19.10742c0.15039-0.60547,0.18359-1.30176,0.05859-2.00781 c-0.00195-0.02832-0.01172-0.05566-0.01563-0.08203c0.35156,0.51758,0.80078,0.85547,1.2793,0.94629 c-0.0957,0.49805-0.10938,1.05176-0.00977,1.61621c0.05469,0.31348,0.14063,0.60547,0.24609,0.87109 C268.70508,19.68555,268.12305,19.18164,267.51953,19.10742z M269.19141,24.02734c-0.01367,0.00391-0.02344,0.01172-0.03516,0.0166 c0.31641-0.66016,0.4375-1.55469,0.28125-2.46191c-0.05664-0.31445-0.14063-0.60449-0.24414-0.875 c0.47266,0.97852,1.26367,1.52637,2.04297,1.30273c0.00977-0.00195,0.01563-0.00391,0.02734-0.00781 c-0.35742,0.68945-0.5,1.6377-0.32813,2.61133c0.02344,0.14844,0.06055,0.28809,0.0957,0.42188 C270.56836,24.25977,269.86914,23.8418,269.19141,24.02734z M268.42383,32.66602c0.69727-0.19629,1.41406,0.5,1.5918,1.5459 c0.18359,1.05176-0.23633,2.06543-0.93359,2.26172c-0.08008,0.02148-0.16016,0.03223-0.24023,0.03223 c-0.61523,0-1.19141-0.65039-1.35156-1.58203C267.30859,33.87305,267.72656,32.86328,268.42383,32.66602z M267.92188,43.70313 c-0.05273,0.0166-0.10547,0.02441-0.16016,0.02441c-0.47852,0-0.95117-0.58398-1.10156-1.40039 c-0.16992-0.91309,0.11914-1.77344,0.64844-1.92188c0.5293-0.14941,1.0957,0.46777,1.26172,1.38184 C268.74414,42.69531,268.44922,43.55566,267.92188,43.70313z M269.84961,48.12109 c-0.05859,0.01855-0.11523,0.02441-0.17383,0.02441c-0.52734,0-1.05078-0.6416-1.21875-1.5498 c-0.18555-1.00586,0.13281-1.95215,0.71484-2.11621c0.58398-0.16602,1.20703,0.51855,1.39648,1.52246 C270.75391,47.00977,270.43945,47.95898,269.84961,48.12109z M270.95508,40.97168 c-0.08008,0.02148-0.16016,0.03223-0.24023,0.03223c-0.61719,0-1.19141-0.65234-1.35352-1.58398 c-0.18164-1.04883,0.23633-2.06055,0.93555-2.25586c0.69922-0.19629,1.41016,0.49707,1.58984,1.54785 C272.07031,39.75977,271.65039,40.77539,270.95508,40.97168z M273.16211,45.6875c-0.08008,0.02441-0.16016,0.03418-0.23828,0.03418 c-0.61914,0-1.19531-0.65234-1.35547-1.58203c-0.18359-1.0498,0.23438-2.0625,0.93555-2.25781 c0.69727-0.19824,1.41016,0.49805,1.58984,1.54785C274.27344,44.47754,273.85742,45.49316,273.16211,45.6875z M264.96094,79.2876 c-0.125,0.47656-0.17383,1.01172-0.12695,1.57227c-0.39648-0.38477-0.86133-0.58984-1.33203-0.56055 c0.15234-0.50977,0.19727-1.11133,0.10352-1.73438c-0.02539-0.17969-0.06641-0.35156-0.11328-0.51172 C263.86719,78.729,264.39453,79.17822,264.96094,79.2876z M259.11523,88.61182c-0.02344-0.18164-0.0625-0.35547-0.11133-0.52148 c0.33203,0.66602,0.81641,1.13477,1.33984,1.30273c-0.14844,0.45508-0.22461,0.97461-0.21094,1.51953 c-0.36914-0.25781-0.78125-0.37695-1.19336-0.30078C259.15234,90.0415,259.22656,89.34424,259.11523,88.61182z M257.88477,96.09229 c0.30469,0.48047,0.67969,0.83789,1.08789,1.01953c-0.12891,0.55469-0.16016,1.17578-0.07617,1.82031 c-0.375-0.31445-0.80469-0.46484-1.23828-0.38281c-0.09961,0.01953-0.19727,0.05078-0.28516,0.08984 C257.81445,98.04932,258.0293,97.09814,257.88477,96.09229z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.15381,
    y1: 487.25146,
    x2: -141.12881,
    y2: 487.25146,
    gradientTransform: "matrix(-29.32836 -34.95218 -34.95218 29.32836 13111.09668 -19206.38672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M220.88281,17.10352c-0.08203-0.47168-0.36914-0.8125-0.67773-0.8125 c-0.03906,0-0.07813,0.00684-0.11523,0.01855c-0.34766,0.0957-0.54883,0.61621-0.45508,1.14551 c0.0957,0.53809,0.44922,0.90039,0.79688,0.80273C220.77734,18.16113,220.97852,17.64551,220.88281,17.10352z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.14502,
    y1: 486.93994,
    x2: -141.12375,
    y2: 486.93994,
    gradientTransform: "matrix(-29.29808 -34.91608 -34.91608 29.29808 13108.88965 -19196.05469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M265.75977,24.60547c-0.19727-1.12598-0.87891-1.91602-1.5957-1.91602 c-0.08789,0-0.17773,0.01172-0.26563,0.03809c-0.80859,0.22754-1.28906,1.42773-1.06445,2.69824 c0.22461,1.26367,1.05273,2.10938,1.86328,1.88379C265.50391,27.08398,265.98047,25.86719,265.75977,24.60547z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12549,
    y1: 486.95557,
    x2: -141.13831,
    y2: 486.95557,
    gradientTransform: "matrix(-29.29816 -34.91618 -34.91618 29.29816 13108.40918 -19195.67383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M267.66602,29.37305c-0.16211-0.91797-0.7207-1.56348-1.30469-1.56348 c-0.07227,0-0.14648,0.01172-0.2168,0.03223c-0.65625,0.18359-1.04297,1.17188-0.86328,2.19922 c0.18359,1.03418,0.86328,1.71484,1.52148,1.53027C267.46289,31.38574,267.84766,30.40332,267.66602,29.37305z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13232,
    y1: 487.09814,
    x2: -141.13232,
    y2: 487.09814,
    gradientTransform: "matrix(-29.29003 -34.9065 -34.9065 29.29003 13099.88379 -19186.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M246.99023,25.45117c-0.05078,0-0.09961,0.00586-0.15039,0.02051 c-0.44727,0.12793-0.71875,0.80762-0.59375,1.51367c0.12109,0.70996,0.5918,1.18262,1.04102,1.05859 c0.45703-0.12988,0.72461-0.8125,0.59766-1.52246C247.77734,25.89746,247.39453,25.45117,246.99023,25.45117z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12109,
    y1: 487.12842,
    x2: -141.1308,
    y2: 487.12842,
    gradientTransform: "matrix(-29.30899 -34.92909 -34.92909 29.30899 13106.98828 -19197.53711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M231.69336,11.17773c-0.87109,0.24805-1.38867,1.55371-1.14648,2.92188 c0.23828,1.36816,1.13867,2.27539,2.01367,2.03223c0.87305-0.24609,1.38086-1.55664,1.14453-2.91992 c-0.21289-1.2207-0.95313-2.07422-1.72656-2.07422C231.88086,11.1377,231.78711,11.15137,231.69336,11.17773z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12158,
    y1: 487.14697,
    x2: -141.13321,
    y2: 487.14697,
    gradientTransform: "matrix(-29.30042 -34.91888 -34.91888 29.30042 13102.68848 -19191.50586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M235.5332,18.15918c-0.17773-1.01367-0.79297-1.72949-1.43945-1.72949 c-0.08203,0-0.16016,0.01172-0.24023,0.03613c-0.73242,0.20215-1.16211,1.29395-0.96094,2.43945 c0.19922,1.14063,0.95313,1.9082,1.68359,1.69824C235.30273,20.39746,235.73633,19.30176,235.5332,18.15918z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.11719,
    y1: 487.18994,
    x2: -141.13234,
    y2: 487.18994,
    gradientTransform: "matrix(-29.30311 -34.92209 -34.92209 29.30311 13102.23926 -19191.92969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M232.08398,20.87109c-0.13672-0.77539-0.60547-1.32324-1.09961-1.32324 c-0.0625,0-0.12695,0.00977-0.1875,0.02734c-0.56055,0.15625-0.89063,0.99414-0.73633,1.86621 c0.15039,0.87988,0.72852,1.46387,1.28906,1.30664C231.91016,22.59375,232.23633,21.75391,232.08398,20.87109z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.1582,
    y1: 487.15771,
    x2: -141.12541,
    y2: 487.15771,
    gradientTransform: "matrix(-29.31165 -34.93226 -34.93226 29.31165 13107.08008 -19198.36328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M236.3125,21.57324c-0.05664,0-0.11523,0.00879-0.17188,0.02441 c-0.5293,0.14746-0.83984,0.93555-0.69531,1.76172s0.69141,1.37988,1.2168,1.22656c0.5293-0.14453,0.83789-0.93848,0.69336-1.7627 C237.22656,22.08789,236.7793,21.57324,236.3125,21.57324z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.14111,
    y1: 487.09912,
    x2: -141.13058,
    y2: 487.09912,
    gradientTransform: "matrix(-29.30379 -34.9229 -34.9229 29.30379 13105.80469 -19195.06055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M237.07422,13.44922c-0.81445,0.22852-1.29297,1.4502-1.07031,2.72656 c0.22656,1.27734,1.06641,2.13184,1.87695,1.9043c0.82031-0.23047,1.29883-1.45898,1.07617-2.73047 c-0.19727-1.14063-0.88867-1.93848-1.61523-1.93848C237.25195,13.41113,237.16406,13.42383,237.07422,13.44922z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13232,
    y1: 487.17725,
    x2: -141.13232,
    y2: 487.17725,
    gradientTransform: "matrix(-29.30067 -34.91918 -34.91918 29.30067 13101.71484 -19190.77148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M227.46484,16.87988c0.21094,1.2041,1.00391,2,1.78125,1.7793 c0.75977-0.21191,1.21289-1.36523,1.00391-2.56738c-0.1875-1.06836-0.83594-1.82227-1.51563-1.82227 c-0.08594,0-0.17188,0.01172-0.25586,0.03613C227.70898,14.51953,227.25781,15.67383,227.46484,16.87988z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.14502,
    y1: 487.22314,
    x2: -141.1301,
    y2: 487.22314,
    gradientTransform: "matrix(-29.30119 -34.9198 -34.9198 29.30119 13100.28906 -19189.75195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M226.73047,18.97363c-0.13867-0.80566-0.625-1.36816-1.13672-1.36816 c-0.06445,0-0.12695,0.00781-0.18945,0.02637c-0.57617,0.16406-0.91797,1.02539-0.75977,1.92969 c0.1582,0.90234,0.75391,1.50391,1.33203,1.3418C226.54492,20.74316,226.88672,19.87305,226.73047,18.97363z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13965,
    y1: 487.06592,
    x2: -141.12854,
    y2: 487.06592,
    gradientTransform: "matrix(-29.30223 -34.92103 -34.92103 29.30223 13106.18848 -19194.99219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M242.36719,15.29395c-0.77344,0.21777-1.22461,1.37012-1.01758,2.57715 c0.2168,1.21484,1.01563,2.02637,1.7832,1.80469c0.77539-0.2168,1.22656-1.37598,1.01953-2.58008 c-0.19141-1.08203-0.84375-1.83594-1.53125-1.83594C242.53711,15.25977,242.45117,15.26953,242.36719,15.29395z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13086,
    y1: 487.11182,
    x2: -141.13086,
    y2: 487.11182,
    gradientTransform: "matrix(-29.30518 -34.92455 -34.92455 29.30518 13105.9248 -19195.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M240.79883,19.88379c-0.1543-0.89844-0.70508-1.53613-1.2832-1.53613 c-0.07031,0-0.14258,0.00781-0.21484,0.02734c-0.64258,0.18262-1.02344,1.16016-0.84766,2.16895 c0.17773,1.01563,0.84375,1.6875,1.49219,1.50781C240.59375,21.86719,240.97852,20.90137,240.79883,19.88379z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.1377,
    y1: 487.03174,
    x2: -141.12671,
    y2: 487.03174,
    gradientTransform: "matrix(-29.31093 -34.93141 -34.93141 29.31093 13111.12988 -19201.57227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M247.83008,17.17383c-0.78125,0.21973-1.23828,1.38574-1.02148,2.61133 c0.21094,1.22266,1.01953,2.04199,1.79688,1.82227c0.78125-0.21973,1.24023-1.39551,1.02734-2.61426 c-0.1875-1.0918-0.85156-1.85352-1.54492-1.85352C248.00195,17.13965,247.91797,17.14941,247.83008,17.17383z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.16162,
    y1: 487.12451,
    x2: -141.11995,
    y2: 487.12451,
    gradientTransform: "matrix(-29.31608 -34.93754 -34.93754 29.31608 13110.13086 -19202.17969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M241.83008,23.81543c-0.04883,0-0.09375,0.00586-0.14063,0.02051 c-0.41797,0.11523-0.66406,0.74414-0.54883,1.39746c0.11328,0.65234,0.54688,1.08984,0.96094,0.97168 c0.41797-0.11719,0.66992-0.74121,0.55273-1.39746C242.55273,24.22363,242.19922,23.81543,241.83008,23.81543z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.14209,
    y1: 487.08154,
    x2: -141.12671,
    y2: 487.08154,
    gradientTransform: "matrix(-29.30921 -34.92936 -34.92936 29.30921 13108.69629 -19199.03906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M245.92188,22.0293c-0.13672-0.77539-0.60547-1.31738-1.09961-1.31738 c-0.06445,0-0.125,0.00586-0.18945,0.02344c-0.55273,0.1582-0.88281,0.98828-0.72461,1.86816 c0.15039,0.86621,0.72461,1.44824,1.2832,1.29199C245.75,23.7373,246.07617,22.90137,245.92188,22.0293z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.11133,
    y1: 487.05029,
    x2: -141.13696,
    y2: 487.05029,
    gradientTransform: "matrix(-29.30518 -34.92455 -34.92455 29.30518 13108.05078 -19197.37109)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M251.46289,23.85156c-0.16016-0.91992-0.71094-1.5625-1.29688-1.5625 c-0.07422,0-0.14844,0.01074-0.22266,0.03027c-0.65234,0.18262-1.03516,1.16797-0.86133,2.2041 c0.18359,1.02051,0.85938,1.70215,1.51172,1.51758C251.25586,25.85547,251.64648,24.87109,251.46289,23.85156z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.10254,
    y1: 487.03271,
    x2: -141.15132,
    y2: 487.03271,
    gradientTransform: "matrix(-29.29185 -34.90867 -34.90867 29.29185 13102.94922 -19189.33594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M258.00391,29.62305c-0.03906,0-0.07617,0.00488-0.11133,0.0166 c-0.34766,0.0957-0.54883,0.6123-0.45117,1.15137c0.08984,0.53223,0.44922,0.88867,0.78711,0.79492 c0.34766-0.09863,0.54688-0.6123,0.45508-1.14453C258.5957,29.96191,258.30859,29.62305,258.00391,29.62305z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.15967,
    y1: 487.00146,
    x2: -141.10883,
    y2: 487.00146,
    gradientTransform: "matrix(-29.29845 -34.91653 -34.91653 29.29845 13106.88379 -19194.48633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M264.3125,32.41406c-0.12891-0.71875-0.56445-1.2168-1.01953-1.2168 c-0.05469,0-0.11328,0.00781-0.16992,0.02441c-0.51367,0.14355-0.81836,0.9082-0.67188,1.71387 c0.14258,0.80566,0.67188,1.33594,1.18359,1.19238C264.15234,33.9834,264.44922,33.21777,264.3125,32.41406z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13184,
    y1: 486.98584,
    x2: -141.13184,
    y2: 486.98584,
    gradientTransform: "matrix(-29.29996 -34.91833 -34.91833 29.29996 13108.11133 -19195.92578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M260.85547,25.95508c-0.65625,0.18652-1.04297,1.17676-0.86328,2.20215 c0.18164,1.02441,0.85742,1.70996,1.51367,1.52051c0.6582-0.17969,1.04688-1.16602,0.86523-2.19043 c-0.16211-0.91602-0.71484-1.55957-1.29688-1.56152C261.00195,25.92578,260.92969,25.93555,260.85547,25.95508z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.11523,
    y1: 487.06592,
    x2: -141.13962,
    y2: 487.06592,
    gradientTransform: "matrix(-29.29852 -34.91662 -34.91662 29.29852 13104.66699 -19192.6582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M252.47656,27.85742c-0.03711,0-0.07617,0.00391-0.11523,0.01563 c-0.34375,0.09473-0.54102,0.6084-0.45117,1.15039c0.09375,0.53223,0.44922,0.89648,0.79297,0.79785 c0.33984-0.0957,0.54688-0.61426,0.44922-1.14941C253.06836,28.19141,252.7793,27.85742,252.47656,27.85742z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13184,
    y1: 487.01904,
    x2: -141.13184,
    y2: 487.01904,
    gradientTransform: "matrix(-29.30349 -34.92253 -34.92253 29.30349 13108.40527 -19197.17969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M256.74414,25.69922c-0.16406-0.92969-0.72852-1.58984-1.32617-1.58984 c-0.07617,0-0.15234,0.00977-0.22656,0.03223c-0.66992,0.18848-1.06641,1.19629-0.88281,2.24414 c0.18359,1.05762,0.87891,1.75195,1.54883,1.56934C256.5332,27.76563,256.92773,26.75977,256.74414,25.69922z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12988,
    y1: 487.32568,
    x2: -141.14009,
    y2: 487.32568,
    gradientTransform: "matrix(-29.29823 -34.91628 -34.91628 29.29823 13095.50586 -19184.87305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M259.57227,71.76416c-0.07813,0-0.1543,0.00977-0.23242,0.02734 c-0.83594,0.19922-1.34961,1.41406-1.13867,2.72461c0.20703,1.30664,1.05469,2.20117,1.89258,2.00977 c0.83984-0.19922,1.34375-1.41406,1.13672-2.71875C261.04297,72.61572,260.33203,71.76416,259.57227,71.76416z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13135,
    y1: 487.60498,
    x2: -141.11945,
    y2: 487.60498,
    gradientTransform: "matrix(-29.30357 -34.92263 -34.92263 29.30357 13087.98633 -19180.09375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M249.31836,99.68018c-0.0625,0-0.12109,0.00586-0.18359,0.01758 c-0.72656,0.1582-1.17578,1.20703-1.01367,2.33984c0.17578,1.13672,0.90625,1.93359,1.63477,1.78516 c0.73633-0.16016,1.18164-1.20313,1.00781-2.34375C250.60938,100.43408,249.98438,99.68018,249.31836,99.68018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12451,
    y1: 487.25928,
    x2: -141.14014,
    y2: 487.25928,
    gradientTransform: "matrix(-29.31567 -34.93705 -34.93705 29.31567 13105.28516 -19197.98828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M261.42773,68.57666c0.54492-0.14063,0.87109-0.94141,0.73047-1.79688 c-0.13086-0.76367-0.59375-1.30859-1.08008-1.30859c-0.05469,0-0.11133,0.00391-0.16406,0.01953 c-0.54492,0.14453-0.87109,0.94727-0.73047,1.80078C260.32422,68.14307,260.88086,68.71729,261.42773,68.57666z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13232,
    y1: 487.58838,
    x2: -141.13232,
    y2: 487.58838,
    gradientTransform: "matrix(-29.29177 -34.90857 -34.90857 29.29177 13083.47754 -19172.98047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M247.76563,98.62158c0.60547-0.13086,0.98633-0.99805,0.83789-1.9375 c-0.125-0.86133-0.64648-1.49023-1.19922-1.49023c-0.05078,0-0.10156,0.00391-0.15039,0.01563 c-0.60352,0.13281-0.98047,0.99805-0.83594,1.9375C246.55273,98.09229,247.16406,98.75049,247.76563,98.62158z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13281,
    y1: 487.66553,
    x2: -141.11694,
    y2: 487.66553,
    gradientTransform: "matrix(-29.29884 -34.917 -34.917 29.29884 13083.89648 -19175.29297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M249.05273,108.35205c-0.11133-0.78711-0.58984-1.36914-1.08984-1.36914 c-0.04102,0-0.08203,0.00391-0.12305,0.01172c-0.54688,0.10156-0.88867,0.88086-0.76758,1.73438 c0.11719,0.85156,0.66016,1.45703,1.20703,1.35156C248.82813,109.979,249.17188,109.20166,249.05273,108.35205z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12695,
    y1: 487.3667,
    x2: -141.1393,
    y2: 487.3667,
    gradientTransform: "matrix(-29.3151 -34.93637 -34.93637 29.3151 13101.22852 -19194.44141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M256.3457,74.80322c-0.06445,0-0.12891,0.00781-0.18945,0.01953 c-0.69336,0.16016-1.11523,1.16797-0.94727,2.24609c0.17578,1.08984,0.87305,1.83203,1.56641,1.67188 c0.6875-0.16406,1.11523-1.17188,0.94141-2.25781C257.5625,75.50244,256.96875,74.80322,256.3457,74.80322z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13086,
    y1: 487.41748,
    x2: -141.13086,
    y2: 487.41748,
    gradientTransform: "matrix(-29.30723 -34.92699 -34.92699 29.30723 13096.20215 -19187.9707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M253.51367,81.19775c0.54492-0.125,0.88281-0.92188,0.74414-1.77539 c-0.125-0.7793-0.58984-1.33203-1.08594-1.33203c-0.05078,0-0.10156,0.00586-0.15234,0.01758 c-0.54297,0.125-0.88477,0.91602-0.74414,1.78125C252.41211,80.74463,252.96289,81.33057,253.51367,81.19775z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12939,
    y1: 487.47998,
    x2: -141.14206,
    y2: 487.47998,
    gradientTransform: "matrix(-29.30348 -34.92252 -34.92252 29.30348 13092.40332 -19183.74219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M252.23438,88.72119c0.67969-0.14844,1.10352-1.11914,0.9375-2.17578 c-0.14453-0.96289-0.71875-1.66406-1.33789-1.66406c-0.06055,0-0.11719,0.00391-0.17578,0.01953 c-0.67578,0.13867-1.0918,1.11133-0.94141,2.16406C250.875,88.12354,251.55859,88.86182,252.23438,88.72119z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12939,
    y1: 487.53955,
    x2: -141.12939,
    y2: 487.53955,
    gradientTransform: "matrix(-29.30957 -34.92978 -34.92978 29.30957 13092.84277 -19185.84375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M250.58398,92.06494c-0.0625,0-0.125,0.00781-0.18945,0.02148 c-0.76953,0.16406-1.24805,1.26758-1.06641,2.45898c0.17578,1.19922,0.94727,2.04297,1.7207,1.87891 c0.76758-0.16211,1.24414-1.26953,1.06641-2.46094C251.94922,92.86377,251.28516,92.06494,250.58398,92.06494z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13037,
    y1: 487.43213,
    x2: -141.13037,
    y2: 487.43213,
    gradientTransform: "matrix(-29.30797 -34.92787 -34.92787 29.30797 13095.93652 -19187.99414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M255.06055,81.84229c-0.06836,0-0.13672,0.00586-0.20508,0.01953 c-0.81836,0.17383-1.32813,1.35156-1.13281,2.625c0.19141,1.27344,1.01563,2.16797,1.82813,1.99609 c0.82031-0.17578,1.33008-1.35156,1.13477-2.625C256.51172,82.68994,255.80469,81.84229,255.06055,81.84229z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13037,
    y1: 487.56006,
    x2: -141.14047,
    y2: 487.56006,
    gradientTransform: "matrix(-29.3024 -34.92123 -34.92123 29.3024 13089.13379 -19180.68164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M252.60352,96.77783c-0.07031,0-0.14258,0.00586-0.21094,0.02148 c-0.84961,0.17969-1.375,1.39258-1.17578,2.71875c0.20117,1.31836,1.04492,2.24414,1.89453,2.06445 c0.8457-0.18164,1.37109-1.39844,1.17188-2.71484C254.10156,97.65479,253.37695,96.77783,252.60352,96.77783z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12988,
    y1: 487.61865,
    x2: -141.15341,
    y2: 487.61865,
    gradientTransform: "matrix(-29.30992 -34.93019 -34.93019 29.30992 13090.20508 -19183.73047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M251.36523,104.43213c-0.05273,0-0.10742,0.00586-0.16211,0.01758 c-0.72266,0.13477-1.17969,1.16602-1.02148,2.29102c0.16602,1.12695,0.88281,1.93164,1.60156,1.79297 c0.73242-0.13672,1.17969-1.16992,1.0293-2.29297C252.66016,105.19971,252.0332,104.43213,251.36523,104.43213z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13037,
    y1: 487.4917,
    x2: -141.12057,
    y2: 487.4917,
    gradientTransform: "matrix(-29.31264 -34.93344 -34.93344 29.31264 13095.7959 -19189.20703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M253.91797,89.09229c-0.07422,0-0.14648,0.00781-0.21875,0.02148 c-0.88086,0.19336-1.42773,1.45508-1.21875,2.82617c0.20508,1.375,1.08594,2.33984,1.96875,2.15039 c0.88477-0.18555,1.42773-1.45117,1.22266-2.82813C255.48438,90.0083,254.72656,89.09229,253.91797,89.09229z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13037,
    y1: 487.70068,
    x2: -141.10538,
    y2: 487.70068,
    gradientTransform: "matrix(-29.31505 -34.93631 -34.93631 29.31505 13089.59277 -19184.66406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M244.84961,109.24854c-0.02539,0-0.05078,0.00195-0.07617,0.00586 c-0.3457,0.06836-0.5625,0.56836-0.49023,1.09766c0.08008,0.54492,0.42383,0.93359,0.77148,0.86523 c0.34961-0.06641,0.57031-0.54883,0.49023-1.09961C245.48047,109.61963,245.17383,109.24854,244.84961,109.24854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12988,
    y1: 487.64795,
    x2: -141.14575,
    y2: 487.64795,
    gradientTransform: "matrix(-29.30509 -34.92445 -34.92445 29.30509 13087.17188 -19179.79688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M246.58789,105.81104c0.53125-0.11328,0.86523-0.88867,0.74023-1.72266 c-0.11328-0.76172-0.57227-1.32031-1.05859-1.32031c-0.04297,0-0.08984,0.00586-0.13477,0.01367 c-0.54297,0.11523-0.875,0.88086-0.74805,1.72266C245.51563,105.33447,246.05273,105.92432,246.58789,105.81104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12256,
    y1: 487.3042,
    x2: -141.14694,
    y2: 487.3042,
    gradientTransform: "matrix(-29.31512 -34.93641 -34.93641 29.31512 13103.43945 -19196.28906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M258.33594,70.93408c0.34375-0.08984,0.54688-0.5957,0.45703-1.13477 c-0.07813-0.48438-0.36914-0.82813-0.67773-0.82813c-0.03516,0-0.07227,0.00781-0.10742,0.01563 c-0.33594,0.08594-0.55078,0.59961-0.45898,1.13672C257.63281,70.65869,257.99023,71.02783,258.33594,70.93408z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12842,
    y1: 487.21631,
    x2: -141.14047,
    y2: 487.21631,
    gradientTransform: "matrix(-29.29864 -34.91676 -34.91676 29.29864 13099.45898 -19188.31836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M264.19727,62.2124c-0.07227,0-0.14453,0.00781-0.21484,0.02734 c-0.70117,0.18359-1.12695,1.22363-0.94531,2.33691c0.18164,1.08984,0.90625,1.8457,1.61328,1.66016 c0.70703-0.17969,1.12695-1.2207,0.94531-2.32227C265.43359,62.92041,264.83203,62.2124,264.19727,62.2124z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.12598,
    y1: 487.15381,
    x2: -141.1416,
    y2: 487.15381,
    gradientTransform: "matrix(-29.30306 -34.92203 -34.92203 29.30306 13103.52441 -19192.98047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M265.7793,58.49316c0.54883-0.15527,0.86523-0.96191,0.7168-1.81738 c-0.13672-0.75781-0.59375-1.29004-1.07813-1.29004c-0.05859,0-0.11914,0.00781-0.17773,0.02539 c-0.54297,0.15039-0.86523,0.96387-0.71289,1.81836C264.67969,58.08594,265.23828,58.64355,265.7793,58.49316z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13086,
    y1: 487.10791,
    x2: -141.13086,
    y2: 487.10791,
    gradientTransform: "matrix(-29.30828 -34.92824 -34.92824 29.30828 13107.38477 -19197.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M269.86328,53.77344c-0.17188-1.00391-0.78125-1.70801-1.41992-1.70801 c-0.07813,0-0.1582,0.00977-0.23633,0.03223c-0.71875,0.2041-1.14063,1.28027-0.94336,2.41016 c0.19531,1.12207,0.93359,1.87402,1.6543,1.66797C269.64063,55.97363,270.0625,54.89551,269.86328,53.77344z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13086,
    y1: 486.97021,
    x2: -141.13086,
    y2: 486.97021,
    gradientTransform: "matrix(-29.30795 -34.92785 -34.92785 29.30795 13112.07227 -19201.50781)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M260.33984,22.65137c-0.19727-1.12793-0.88281-1.91992-1.59766-1.91992 c-0.08984,0-0.17773,0.01172-0.26563,0.03613c-0.81055,0.23047-1.28516,1.4375-1.06445,2.70215 c0.2207,1.26367,1.05469,2.11426,1.86133,1.87988C260.08398,25.12305,260.55469,23.90918,260.33984,22.65137z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -143.13037,
    y1: 487.00342,
    x2: -141.13037,
    y2: 487.00342,
    gradientTransform: "matrix(-29.30795 -34.92785 -34.92785 29.30795 13110.88477 -19200.53516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17791,
    style: {
      stopColor: "#612E88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37765,
    style: {
      stopColor: "#8F5C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61734,
    style: {
      stopColor: "#C18C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79974,
    style: {
      stopColor: "#DFAB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90184,
    style: {
      stopColor: "#EBB631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBB631"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M254.99414,20.97559c-0.19727-1.12793-0.88086-1.91992-1.59375-1.91992 c-0.08789,0-0.17773,0.01367-0.26758,0.03809c-0.80859,0.22754-1.28516,1.43359-1.0625,2.70215 c0.2207,1.26172,1.05078,2.11133,1.86328,1.87988C254.74219,23.44922,255.21094,22.2334,254.99414,20.97559z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M148.42188,94.49072h1.83984l6.53516,16.4707h-1.69922l-1.76758-4.41406h-8.30664l-1.77148,4.41406h-1.58008 L148.42188,94.49072z M149.22461,96.04736l-3.58789,9.08594h7.15039L149.22461,96.04736z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M167.88672,108.12939c0,0.91992,0,1.86523,0.0918,2.83203h-1.43555v-2.14844h-0.04883 c-0.49609,1.08594-1.39258,2.43164-3.89258,2.43164c-2.9751,0-4.10742-1.98438-4.10742-4.625v-7.69141h1.48779v7.3125 c0,2.26563,0.80127,3.72852,2.85205,3.72852c2.71484,0,3.56445-2.38086,3.56445-4.38867v-6.65234h1.48828V108.12939z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M169.74609,109.21533c0.89648,0.44727,1.98242,0.75391,3.14063,0.75391 c1.41602,0,2.66602-0.77734,2.66602-2.14648c0-2.85547-5.7832-2.40625-5.7832-5.89844c0-2.38477,1.93359-3.28125,3.91797-3.28125 c0.63867,0,1.91016,0.14258,2.97266,0.54297l-0.14063,1.29688c-0.7793-0.35352-1.8418-0.56641-2.66797-0.56641 c-1.5332,0-2.59375,0.47266-2.59375,2.00781c0,2.23828,5.92188,1.95898,5.92188,5.89844c0,2.54883-2.38086,3.42188-4.19922,3.42188 c-1.15625,0-2.3125-0.14063-3.37695-0.56641L169.74609,109.21533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M184.5625,100.20166h-2.73633v7.78711c0,1.08594,0.40039,1.98242,1.60352,1.98242 c0.56641,0,0.94531-0.11914,1.36914-0.28516l0.09375,1.22852c-0.35352,0.14258-1.08398,0.33008-1.81641,0.33008 c-2.64258,0-2.73633-1.81641-2.73633-4.01172v-7.03125h-2.35938v-1.27539h2.35938v-2.90234l1.48633-0.51758v3.41992h2.73633 V100.20166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M186.75586,101.61572c0-1.32031,0-1.81641-0.09375-2.68945h1.48633v2.31445h0.04688 c0.54297-1.34766,1.55859-2.59766,3.0918-2.59766c0.35547,0,0.7793,0.07031,1.03906,0.14063v1.55859 c-0.30859-0.0957-0.70898-0.14063-1.08594-0.14063c-2.35938,0-2.99805,2.64063-2.99805,4.8125v5.94531h-1.48633V101.61572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M200.58203,109.02588h-0.04688c-0.6582,1.44141-2.33398,2.21875-3.82227,2.21875 c-3.42188,0-3.96484-2.3125-3.96484-3.39844c0-4.03516,4.29492-4.22266,7.41016-4.22266h0.28516v-0.61328 c0-2.05469-0.73438-3.09375-2.73828-3.09375c-1.25195,0-2.42969,0.28516-3.54102,0.99219v-1.43945 c0.91992-0.44727,2.47852-0.82617,3.54102-0.82617c2.97461,0,4.22266,1.3457,4.22266,4.48438v5.30859 c0,0.9668,0,1.69922,0.11914,2.52344h-1.46484V109.02588z M200.44336,104.89697h-0.42578 c-2.57031,0-5.64063,0.25781-5.64063,2.90234c0,1.58203,1.13477,2.16992,2.50195,2.16992 c3.49219,0,3.56445-3.04102,3.56445-4.33984V104.89697z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.51953,
    y: 93.26221,
    fill: "#272525",
    width: 1.48633,
    height: 17.69727
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M210.30078,95.71729h-1.48438v-1.98438h1.48438V95.71729z M208.81445,98.92627h1.48438v12.0332h-1.48438 V98.92627z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272525",
    d: "M220.02148,109.02588h-0.04688c-0.66016,1.44141-2.33594,2.21875-3.82422,2.21875 c-3.41992,0-3.96289-2.3125-3.96289-3.39844c0-4.03516,4.29492-4.22266,7.41016-4.22266h0.2832v-0.61328 c0-2.05469-0.73242-3.09375-2.73828-3.09375c-1.25,0-2.42969,0.28516-3.53906,0.99219v-1.43945 c0.91797-0.44727,2.47852-0.82617,3.53906-0.82617c2.97461,0,4.22461,1.3457,4.22461,4.48438v5.30859 c0,0.9668,0,1.69922,0.11719,2.52344h-1.46289V109.02588z M219.88086,104.89697h-0.42578 c-2.57031,0-5.63867,0.25781-5.63867,2.90234c0,1.58203,1.13281,2.16992,2.50195,2.16992c3.49023,0,3.5625-3.04102,3.5625-4.33984 V104.89697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M32.47656,59.39941c0,8.8042-7.43359,16.07178-16.23828,16.07178C7.43555,75.47119,0,68.20361,0,59.39941 c0-8.80371,7.39258-16.07227,16.23828-16.07227C25.04297,43.32715,32.47656,50.5957,32.47656,59.39941 M1.99414,59.39941 c0,7.72412,6.43945,14.20459,14.24414,14.20459c7.76563,0,14.24609-6.51953,14.24609-14.20459 c0-7.72363-6.48047-14.2041-14.24609-14.2041C8.43359,45.19531,1.99414,51.67578,1.99414,59.39941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M52.70703,60.31445c-1.82813-1.99512-4.0293-3.11719-6.77148-3.11719 c-4.52539,0-7.93164,3.86328-7.93164,8.2251c0,4.35938,3.36523,8.30664,7.89258,8.30664c2.74023,0,5.31445-1.33203,7.05859-3.44727 v2.5332c-1.95117,1.70313-4.40234,2.65625-6.97656,2.65625c-5.68945,0-9.8418-4.44336-9.8418-10.04883 c0-5.56689,4.23633-9.96826,9.88281-9.96826c2.49219,0,4.77734,0.74707,6.6875,2.36816V60.31445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M73.34766,60.31445c-1.82813-1.99512-4.02734-3.11719-6.76953-3.11719 c-4.52539,0-7.93164,3.86328-7.93164,8.2251c0,4.35938,3.36328,8.30664,7.89258,8.30664c2.73828,0,5.3125-1.33203,7.05664-3.44727 v2.5332c-1.94922,1.70313-4.40234,2.65625-6.97461,2.65625c-5.69141,0-9.84375-4.44336-9.84375-10.04883 c0-5.56689,4.23633-9.96826,9.88477-9.96826c2.49219,0,4.77539,0.74707,6.68555,2.36816V60.31445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M91.95508,55.86914v11.50439c0,1.95313,0.04102,3.9043-1.16211,5.52344 c-1.33008,1.74609-3.57227,2.57422-5.73242,2.57422s-4.40234-0.82813-5.73047-2.57422 c-1.20508-1.61914-1.16406-3.57031-1.16406-5.52344V55.86914h1.86914v10.84033c0,3.69531,0.41602,7.01953,5.02539,7.01953 s5.02539-3.32422,5.02539-7.01953V55.86914H91.95508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M97.88867,59.31641h0.08398c1.41211-2.4502,4.48438-3.8623,7.30859-3.8623 c5.85547,0,9.4707,4.56836,9.4707,10.17725c0,5.60547-3.61523,9.8418-9.38672,9.8418c-2.94922,0-5.81445-1.28711-7.39258-3.73828 h-0.08398v14.53711h-1.86719V55.87012h1.86719V59.31641z M97.76563,65.87744c0,4.48828,3.03125,7.85156,7.64063,7.85156 c4.48438,0,7.47461-3.78125,7.47461-8.05859c0-4.40283-2.86523-8.47217-7.55859-8.47217 C100.42383,57.19824,97.76563,61.26758,97.76563,65.87744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M136.52148,75.05713h-1.87109v-3.44922h-0.08203c-1.41211,2.45313-4.48633,3.86523-7.31055,3.86523 c-5.8125,0-9.4668-4.52539-9.4668-10.13477c0-5.60596,3.61133-9.88428,9.38477-9.88428c2.94922,0,5.77344,1.32813,7.39258,3.73828 h0.08203v-3.32422h1.87109V75.05713z M119.6582,65.33838c0,4.40234,2.9082,8.39063,7.55859,8.39063 c4.90234,0,7.56055-3.98828,7.56055-8.59766c0-4.4458-3.0332-7.93311-7.68555-7.93311 C122.69141,57.19824,119.6582,61.18555,119.6582,65.33838"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#612E88",
    points: "144.16406,75.05713 142.29688,75.05713 142.29688,57.61523 140.17578,57.61523 140.17578,55.86914  142.29688,55.86914 142.29688,49.0166 144.16406,49.0166 144.16406,55.86914 147.52734,55.86914 147.52734,57.61523  144.16406,57.61523  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M153.30078,49.47363c0,0.95605-0.74805,1.7041-1.70313,1.7041c-0.95313,0-1.70117-0.74805-1.70117-1.7041 c0-0.91211,0.74805-1.70215,1.70117-1.70215C152.55273,47.77148,153.30078,48.56152,153.30078,49.47363 M152.51172,75.05713 h-1.86719V55.86914h1.86719V75.05713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M175.35352,65.46338c0,5.68945-4.44336,10.00977-10.0918,10.00977 c-5.52197,0-9.96484-4.5293-9.96484-9.9668c0-5.52588,4.40186-10.05127,9.96484-10.05127 C170.91016,55.45508,175.35352,59.77246,175.35352,65.46338 M157.16406,65.50635c0,4.35938,3.44727,8.22266,7.97461,8.22266 c4.69141,0,8.34766-3.57227,8.34766-8.22266c0-4.73486-3.61328-8.30713-8.34766-8.30713 C160.57031,57.19922,157.16406,61.06055,157.16406,65.50635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M180.0918,58.85938h0.08203c1.11914-2.11719,3.19727-3.40527,5.6875-3.40527 c4.94336,0,6.31445,3.07324,6.31445,8.01709v11.58594h-1.86914V63.47119c0-3.44775-0.41406-6.27393-4.60938-6.27393 c-4.81836,0-5.60547,4.48633-5.60547,8.39111v9.46875h-1.86914V55.87012h1.86914V58.85938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M213.77344,75.05713h-1.87109v-3.44922h-0.08203c-1.41211,2.45313-4.48633,3.86523-7.30859,3.86523 c-5.8125,0-9.4668-4.52539-9.4668-10.13477c0-5.60596,3.60938-9.88428,9.38281-9.88428c2.95117,0,5.77344,1.32813,7.39258,3.73828 h0.08203v-3.32422h1.87109V75.05713z M196.91211,65.33838c0,4.40234,2.90625,8.39063,7.55859,8.39063 c4.90039,0,7.55859-3.98828,7.55859-8.59766c0-4.4458-3.0332-7.93311-7.68555-7.93311 C199.94336,57.19824,196.91211,61.18555,196.91211,65.33838"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.33984,
    y: 40.7959,
    fill: "#612E88",
    width: 1.86719,
    height: 34.26123
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#612E88",
    points: "16.39648,111.04736 14.40234,111.04736 14.40234,81.60205 6.30273,81.60205 6.30273,79.73291  24.49414,79.73291 24.49414,81.60205 16.39648,81.60205  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M30.64258,79.74268V94.8501h0.08398c1.11914-2.11719,3.19727-3.40625,5.6875-3.40625 c4.94336,0,6.31445,3.07422,6.31445,8.01563v11.58984h-1.86914V99.45947c0-3.44531-0.41602-6.26953-4.61133-6.26953 c-4.81641,0-5.60547,4.48438-5.60547,8.38867v9.4707h-1.86914V79.74268H30.64258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M48.29492,101.61963c-0.12695,4.85938,3.23828,8.09961,7.68164,8.09961 c2.99023,0,5.40039-1.78711,6.76953-4.36133l1.57813,0.91406c-1.74414,3.32031-4.81836,5.19141-8.5957,5.19141 c-5.68945,0-9.30469-4.60938-9.30469-10.05078c0-5.35938,3.69922-9.9668,9.30469-9.9668 c5.81445,0,9.25977,4.65039,9.21875,10.17383H48.29492z M63.07813,99.87549c-0.45508-3.5293-3.36328-6.68555-7.30859-6.68555 c-3.9043,0-7.14258,3.07031-7.47461,6.68555H63.07813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M71.3457,94.35205h0.08398c0.74609-1.74414,2.11719-2.9082,4.15039-2.9082 c0.74805,0,1.37109,0.16797,2.03711,0.45898l-0.99805,1.66211c-0.45703-0.25-0.83008-0.375-1.32813-0.375 c-4.19336,0-3.94531,5.23242-3.94531,8.05664v9.80273h-1.86914v-19.1875h1.86914V94.35205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M97.875,111.04736h-1.87109v-3.44727h-0.08203c-1.41211,2.45313-4.48633,3.86328-7.30859,3.86328 c-5.81445,0-9.46875-4.52734-9.46875-10.13281c0-5.60938,3.61133-9.88477,9.38672-9.88477 c2.94727,0,5.77148,1.32813,7.39063,3.73828h0.08203v-3.32422H97.875V111.04736z M81.01172,101.33057 c0,4.40234,2.9082,8.39063,7.55859,8.39063c4.90234,0,7.56055-3.98828,7.56055-8.59961c0-4.44336-3.03516-7.93164-7.68359-7.93164 C84.04492,93.18994,81.01172,97.17822,81.01172,101.33057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612E88",
    d: "M104.16406,95.30713h0.08203c1.41211-2.44922,4.48438-3.86328,7.30859-3.86328 c5.85547,0,9.4707,4.57031,9.4707,10.17578c0,5.60742-3.61523,9.84375-9.38672,9.84375c-2.94922,0-5.81445-1.28906-7.39258-3.73828 h-0.08203v14.53516h-1.86914V91.86182h1.86914V95.30713z M104.03906,101.86963c0,4.48438,3.03125,7.84961,7.64258,7.84961 c4.48242,0,7.47266-3.7793,7.47266-8.05859c0-4.40039-2.86328-8.4707-7.55664-8.4707 C106.69727,93.18994,104.03906,97.26025,104.03906,101.86963"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#612E88",
    points: "121.14453,91.86182 123.09766,91.86182 131.27734,109.22119 138.62891,91.86182  140.53906,91.86182 127.66602,122.26025 125.75586,122.26025 130.36523,111.38135  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApOccupationalTherapyAustralia);
export default __webpack_public_path__ + "static/media/_ap_occupational-therapy-australia.34c4c930eb9b9ec5079ac45ec0233fc6.svg";
export { ForwardRef as ReactComponent };